"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n  padding: 0 20px;\n  font-weight: ", ";\n  box-sizing: border-box;\n  position: relative;\n  cursor: pointer;\n  font-family: ", ";\n  font-size: ", "px;\n  color: ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var NavItemContainer = (0, _styledComponents.default)('div')(_templateObject(), function (props) {
  return props.theme.typography.fontWeightRegular;
}, function (props) {
  return props.theme.typography.fontFamily;
}, function (props) {
  return props.theme.typography.fontSize;
}, function (props) {
  return props.theme.palette.getContrastText(props.theme.palette.secondary.main);
}, function (props) {
  return props.active && "\n    &:after{\n      content:\"\";\n      position:absolute;\n      background-color: ".concat(props.theme.palette.getContrastText(props.theme.palette.secondary.main), ";\n      height:4px;\n      width:100%;\n      bottom:0;\n      left: 0;\n    }\n  ");
});

var NavItem = function NavItem(_ref) {
  var children = _ref.children,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, ["children", "label"]);

  return _react.default.createElement(NavItemContainer, props, _react.default.createElement("span", null, children && (typeof children === 'string' ? children.toUpperCase() : children)), label && _react.default.createElement("span", null, label));
};

NavItem.defaultProps = {
  label: ''
};
var _default = NavItem;
exports.default = _default;